var ObjectHelper = (function () {
    function ObjectHelper() {
    }
    ObjectHelper.merge = function (source, target, cover) {
        if (cover === void 0) { cover = false; }
        for (var key in target) {
            if (target.hasOwnProperty(key)) {
                var element = target[key];
                if (cover) {
                    source[key] = element;
                }
                else if (!(key in source)) {
                    source[key] = element;
                }
            }
        }
    };
    ObjectHelper.serialize = function (obj) {
        var result;
        try {
            if (typeof obj === "string") {
                result = JSON.parse(obj);
            }
            else {
                result = JSON.parse(JSON.stringify(obj));
            }
        }
        catch (e) {
            result = null;
        }
        return result;
    };
    ObjectHelper.mergeChildToSource = function (obj) {
        if (!obj) {
            return null;
        }
        var deletekeys = [];
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var element = obj[key];
                if (typeof element === "object") {
                    this.merge(obj, element);
                    deletekeys.push(key);
                }
            }
        }
        for (var index = 0; index < deletekeys.length; index++) {
            var element = deletekeys[index];
            delete obj[element];
        }
    };
    ObjectHelper.parseJSON = function (str) {
        if (!str) {
            return null;
        }
        if (typeof str !== "string" || Object.prototype.toString.call(str) !== '[object String]') {
            return str;
        }
        var result = null;
        try {
            result = JSON.parse(str);
        }
        catch (e) {
        }
        return result;
    };
    return ObjectHelper;
}());
export default ObjectHelper;
